import { render, staticRenderFns } from "./FormDetailConfig.vue?vue&type=template&id=5bfe6592&scoped=true&lang=pug&"
import script from "./FormDetailConfig.vue?vue&type=script&lang=js&"
export * from "./FormDetailConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailConfig.vue?vue&type=style&index=0&id=5bfe6592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe6592",
  null
  
)

export default component.exports